import React, { useCallback, useMemo, useState } from "react";
import {
  Button,
  ButtonBase,
  Checkbox,
  CircularProgress,
  Dialog,
  Paper,
  Slide,
  Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

import styles from "./Style.module.css";
import { PrimaryButton } from "../../../../../components/Buttons/PrimaryButton";
import useAssociatePetHook from "./AssociatePetDialog.hook";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const AssociatePetDialog = ({ isOpen, handleToggle, updatePetList }) => {
  const {
    changeTextData,
    handleSubmit,
    isSubmitting,
    data,
  } = useAssociatePetHook({ isOpen, updatePetList, handleToggle });

  return (
    <div>
      <Dialog
        onBackdropClick={() => {}}
        keepMounted
        fullWidth={true}
        
        PaperProps={{
          sx: { borderRadius: "9px" },
        }}
        sx={{
          width: "566px",
          maxWidth: "100%",
          margin: "auto",
        }}
        TransitionComponent={Transition}
        open={isOpen}
        onClose={() => {}}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <div className={styles.DialogWrap}>
          <div className={styles.Wrappper}>
            <div>
              <Typography variant={"subtitle1"}>Associate Pet</Typography>
              <Typography variant={"caption"}>
                Select the pet you want to add
              </Typography>
            </div>

            <ButtonBase onClick={handleToggle} className={styles.close}>
              <CloseIcon />
            </ButtonBase>
          </div>
          <div className={styles.petCont}>
            {data?.length > 0 &&
              data?.map((val, index) => (
                <div key={`asso_${index}`} className={styles.petCont}>
                  <div className={styles.petWrap}>
                    <Checkbox
                      size="small"
                      style={{ padding: "0" }}
                      name={"is_selected"}
                      checked={val.is_selected}
                      onChange={() => changeTextData(val?.id)}
                    />
                    <div className={styles.wrap}>
                      <img
                        src={val?.image}
                        alt=""
                        crossOrigin="anonymous"
                        className={styles.imgWrap}
                      />
                    </div>
                    <div className={styles.textWrap}>
                      <Typography variant={"caption"}>{val?.name}</Typography>
                    </div>
                  </div>
                </div>
              ))}
          </div>

          <div className={styles.printFlex}>
            <PrimaryButton
              disable={isSubmitting}
              onClick={handleSubmit}
              variant={"contained"}
              color={"primary"}
            >
              {isSubmitting ? (
                <CircularProgress color="success" size="20px" />
              ) : (
                "SAVE"
              )}
            </PrimaryButton>
          </div>
        </div>
      </Dialog>
    </div>
  );
};

export default AssociatePetDialog;
